module.exports = __webpack_public_path__ + "img/pc_1.b862ca92.jpg";